import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'sb-value-definition',
  templateUrl: './sb-value-definition.component.html',
  styleUrls: ['./sb-value-definition.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SbValueDefinitionComponent {
  @Input() text: string = 'n. def.';
  @Input() lengthLimit: number = 30;
}
